export const PNG_FILE_MIME_TYPE = 'image/png';
export const JPEG_FILE_MIME_TYPE = 'image/jpeg';
export const XLSX_FILE_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const CSV_FILE_TYPE = 'text/csv';

export const DSP_XANDR = 'XANDR';
export const DSP_VISTAR = 'VISTAR';
export const DSP_CRITEO = 'CRITEO';
export const DSP_ADFORM = 'ADFORM';
export const DSP_AMAZON = 'AMAZON';
export const DSP_FREEWHEEL = 'FREEWHEEL';

/**
 * DSPs whose advertisers configure conversions on the "Pixel code" page rather than the
 * hand-written legacy pixel. Both drive the same published pixel config; they differ only
 * in what the backend does with a conversion rule -- Adform carries the category in sv1/sv2
 * on one advertiser-level pixel, FreeWheel gets one conversion tag per rule.
 *
 * The other DSPs have no pixel config support in the backend, so they stay on the legacy
 * page; sending them to "Pixel code" would show an editor whose saves have nowhere to go.
 */
export const DSPS_WITH_PIXEL_CONFIG: string[] = [DSP_ADFORM, DSP_FREEWHEEL];

export const supportsPixelConfig = (dsp?: string | null): boolean =>
  !!dsp && DSPS_WITH_PIXEL_CONFIG.includes(dsp);

/**
 * How each DSP is written in user-facing copy. FreeWheel capitalises its second
 * W, so this cannot be derived by title-casing the constant.
 */
export const DSP_LABELS: Record<string, string> = {
  [DSP_XANDR]: 'Xandr',
  [DSP_VISTAR]: 'Vistar',
  [DSP_CRITEO]: 'Criteo',
  [DSP_ADFORM]: 'Adform',
  [DSP_AMAZON]: 'Amazon',
  [DSP_FREEWHEEL]: 'FreeWheel',
};
